/**
 * Application Entry Point
 * 
 * Sets up React with:
 * - React Router for navigation
 * - AuthProvider for authentication state
 * - ToastProvider for transient feedback
 * - Global styles via Tailwind CSS
 *
 * ToastProvider sits here rather than in Layout so that UNAUTHENTICATED pages
 * outside the authed shell can report outcomes too. `/admin/break-glass` is the
 * first such page: it lives outside Layout by necessity, and `useToast()`
 * throws outside a provider by design, so a Layout-scoped provider would have
 * made the emergency page the one page that cannot tell you what went wrong.
 */

import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { AuthProvider } from './hooks/useAuth'
import { ToastProvider } from './components/Toast'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
